import { render, staticRenderFns } from "./PaymentMethodChart.vue?vue&type=template&id=837ea0d6&"
import script from "./PaymentMethodChart.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports